<!-- eslint-disable no-unused-vars -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Renewables / BESS" :path="breadcrumbPath" />

    <!-- Customer selector -->
    <div class="row m-0 width-100-p">
      <div
        class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
      >
      <el-col :span="24">
                <h5 class="text-white mt-3 ml-1">Upload for a Customer</h5>
                <span class="moderat-white-12 ml-1">
                  * Use the customer selector to select the customer for the upload
                </span>
      </el-col>
  
      <!-- custom filter scenario 1 -->
      <!-- customer filter (admin only) & location filter & MP filter & custom date -->
      <div class="custom-filter-container pr-20">
      <!-- Custom filter -->
      <el-row >
          <div 
            class="custom-filter-container-wrapper d-flex row y-center m-0 mb-12 width-100-p"
            >
                <el-form :label-position="`top`" class="custom-filter-form d-flex">
                <el-space
                    class="custom-filter-space"
                    fill
                    >
                    <el-row gutter="20">
                      <el-col 
                          :span="$vuetify.display.width > 1280 ? 10 : 24" 
                          :class="$vuetify.display.width > 645 ? 'x-start' : 'x-center'" >
                            <el-form-item
                                  class="custom-filter-item label-style"
                                  prop="customer"
                                  label="Customer"
                              >
                                  <!-- customer select -->
                                  <div>
                                    <el-tooltip
                                    effect="light"
                                    placement="top"
                                    show-after="500"
                                    hide-after="300"
                                    >
                                    <template #content >
                                      <span :style="{fontSize: '12px', textAlign: 'left'}"> Upload for this customer</span>
                                    </template>
                                      <el-select
                                          v-model="customerId"
                                          placeholder="Select Customer"
                                          class="custom-filter-select"
                                          clearable
                                          >
                                          <el-option
                                              v-for="item in customerList"
                                              :key="item.id"
                                              :label="item.full_name"
                                              :value="item.id"
                                              >
                                              <span>{{ item.full_name }}</span>
                                              <!-- <span>{{ item.phone }}</span> -->
                                          </el-option>
                                      </el-select>
                                      </el-tooltip>
                                  </div>
                            </el-form-item>
                      </el-col>
                    </el-row>
                </el-space>
                </el-form>
          </div>
      </el-row>
      </div>
    </div>
    </div>

    <div class="row px-0 m-0" v-if="uploadFilter == `1`" :class="$vuetify.display.width >= 1400 ? 'mt-30' : $vuetify.display.width >= 768 ? 'mt-30' : $vuetify.display.width >= 375 ? 'mt-24' : 'mt-20'">
      <!-- alert -->
      <el-row class="m-0 mb-3 px-0">
        <el-col
          :span="24"
          class="p-0"
          :class="$vuetify.display.width < 750 ? 'x-center' : ''"
        >
          <el-alert
            v-if="showMissingColumns"
            @close="missingAlertCloseHandle"
            class="ma-2"
            title="Uploaded file has a wrong structure"
            type="error"
            show-icon
          >
          <p class="mb-0" style="color: #f56c6c">
              {{ "To upload a on-site renewables file, these columns are needed in the file:" }}
            </p>
            <ul>
              <li v-for="(miss, i) in missingColumns" :key="i">
                {{ i + 1 + ". " + miss }}
              </li>
            </ul>
          </el-alert>
          <el-alert
            v-if="missingOptionalColumns.length > 0"
            @close="missingOptionalAlertCloseHandle"
            class="ma-2"
            title="Uploaded file has a wrong structure"
            type="warning"
            show-icon
          >
            <p class="mb-0" style="color: #f56c6c">
              {{ "These optional columns are missing from the uploaded file. A value of zero will be applied to these columns for all submitted records." }}
            </p>
            <ul>
              <li v-for="(miss, i) in missingOptionalColumns" :key="i">
                {{ i + 1 + ". " + miss }}
              </li>
            </ul>
          </el-alert>
        </el-col>
      </el-row>
      <!-- uploader -->
      <el-row class="m-0 mb-3 px-0">
        <el-col
          :span="24"
          class="p-0"
          :class="$vuetify.display.width < 750 ? 'x-center' : ''"
        >
          <el-upload
            ref="uploadMain"
            class="upload-demo width-100-p"
            action="#"
            :limit="1"
            :auto-upload="false"
            drag
            :on-change="onChange"
            :on-remove="onRemove"
            :on-exceed="handleExceed"
            :file-list="fileList"
          >
            <!-- <i class="fa fa-cloud-upload f-46"></i> -->
            <svg class="stroke-icon width-40 height-35">
              <use
                href="@/assets/svg/icon-sprite.svg#drag-and-drop-icon-cloud"
              ></use>
            </svg>
            <div class="el-upload__text text-white">
              <em>Drop file here</em> or click to upload
            </div>
            <template #tip>
              <div class="el-upload__tip text-white">
                Upload your Excel file
              </div>
            </template>
          </el-upload>
        </el-col>
      </el-row>
      <!-- progress -->
      <el-row class="m-0 mb-3 px-0">
        <el-col
          :span="24"
          class="p-0"
          :class="$vuetify.display.width < 750 ? 'x-center' : ''"
        >
          <el-progress
            v-if="hasLargeFile"
            :percentage="sendingFilePercent"
            stroke-width="10"
            :format="progressFormat"
            :status="sendingFilePercent == 100 ? 'success' : ''"
            class="progress-style"
          />
          <el-alert
            v-if="hasLargeFile && sendingFilePercent == 100"
            title="Send Success"
            :type="`success`"
            class="mt-5"
            show-icon
          >
            <p class="mb-0" style="color: #67c23a">
              {{
                "The file with a size of " +
                sessionsFileSize +
                " MB is received successfully. The result of this transaction, including valid and invalid sessions will be emailed to you shortly."
              }}
            </p>
          </el-alert>
        </el-col>
      </el-row>
      <!-- stepper -->
      <el-row class="m-0 mb-3 px-0" v-if="!hasLargeFile">
        <el-col
          :span="24"
          class="p-0"
          :class="$vuetify.display.width < 750 ? 'x-center' : ''"
        >
          <el-steps
            :active="activeStep"
            finish-status="success"
            :process-status="successStep"
            simple
            class="step-style width-100-p"
          >
            <el-step title="Load Data" :description="stepLoadDesc" />
            <el-step
              @click="stepperChange(2)"
              style="cursor: pointer"
              title="Check Validate"
              :description="stepValidDesc"
            />
            <el-step
              @click="stepperChange(3)"
              style="cursor: pointer"
              title="Send Data"
              :description="stepSendDesc"
            />
          </el-steps>
        </el-col>
      </el-row>
      <!-- table -->
      <el-row class="m-0 mb-3 px-0" v-if="!hasLargeFile">
        <el-col
          :span="24"
          class="y-center"
          :class="$vuetify.display.width < 750 ? 'x-center' : ''"
        >
          <div class="row m-0 width-100-p">
            <div
              class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
            >
              <el-col :span="24" class="mb-2">
                <div class="row m-0">
                  <!-- <el-col
                    class="pl-0"
                    :span="$vuetify.display.width >= 750 ? 14 : 24"
                    :class="
                      $vuetify.display.width < 750
                        ? 'x-center p-0 order-3 mt-2'
                        : ''
                    "
                  >
                    <el-input
                      size="large"
                      v-model="search"
                      placeholder="Type to search by site name, charger ID, port ..."
                      :prefix-icon="Search"
                      class="table-search"
                    />
                  </el-col> -->
                  <el-col
                    class="p-0"
                    :span="24"
                    :class="
                      $vuetify.display.width < 750
                        ? 'x-center width-100-p'
                        : 'd-flex justify-content-start'
                    "
                  >
                    <el-button
                      @click="handleExportFile"
                      color="#ddf0ac"
                      class="height-40 rounded-3"
                      :class="$vuetify.display.width < 750 ? 'width-100-p' : ''"
                    >
                      <i class="fa fa-file-excel-o"></i>
                    </el-button>
                    <el-button
                      @click="handlePerv"
                      color="#ddf0ac"
                      class="height-40 rounded-3"
                      :class="$vuetify.display.width < 750 ? 'width-100-p' : ''"
                    >
                      <i class="fa fa-angle-left"></i>
                      <span class="moderat-btn-apply pl-3"> Prev </span>
                    </el-button>
                    <el-button
                      @click="handleNext"
                      color="#ddf0ac"
                      class="height-40 rounded-3"
                      :class="$vuetify.display.width < 750 ? 'width-100-p' : ''"
                    >
                      <span class="moderat-btn-apply pr-3"> Next </span>
                      <i class="fa fa-angle-right"></i>
                    </el-button>
                  </el-col>
                  
                </div>
              </el-col>
              <el-col :span="24" class="p-0">
                <div
                  class="ma-0 width-100-p"
                  v-loading="loading"
                  :element-loading-spinner="svg"
                  element-loading-svg-view-box="-10, -10, 50, 50"
                  element-loading-background="rgba(122, 122, 122, 0.8)"
                >
                  <el-alert
                    v-if="responseAlert.visible"
                    :title="responseAlert.title"
                    :type="responseAlert.type"
                    show-icon
                  >
                    <p
                      class="mb-0"
                      style="color: #67c23a"
                      v-if="response_alert.success_count > 0"
                    >
                      {{ responseAlert.success_desc }}
                    </p>
                    <p
                      class="mb-0"
                      style="color: #f56c6c"
                      v-if="response_alert.pending_count > 0"
                    >
                      {{ responseAlert.pending_desc }}
                    </p>
                    <p
                      class="mb-0"
                      style="color: #e6a23c"
                      v-if="response_alert.duplicate_count > 0"
                    >
                      {{ responseAlert.duplicate_desc }}
                    </p>
                  </el-alert>
                  <div class="custom-table-design">
                  <el-table
                    :data="filter_excel_data"
                    :fit="true"
                    height="50vh"
                    stripe
                    class="my-2 data-table"
                    :row-class-name="tableRowClassName"
                    @row-click="handleRowClick"
                    scrollbar-always-on
                  >
                    <el-table-column type="expand">
                      <template #default="props">
                        <div
                          class="pa-5"
                          v-if="
                            props.row.error_message != null &&
                            props.row.error_message.length > 0
                          "
                        >
                          <span class="text-red"> Attention : </span>
                          <p
                            m="t-0 b-2"
                            class="mb-0"
                            v-for="(error, i) in props.row.error_message"
                            :key="i"
                          >
                            {{ i + 1 + " : " + error }}
                          </p>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      :label="'Site Name'"
                      :prop="'site_name'"
                      :width="$vuetify.display.width <= 1810 ? 200 : ''"
                      sortable
                    />
                    <el-table-column
                      :label="'Time'"
                      :prop="'time'"
                      :width="$vuetify.display.width <= 1810 ? 150 : ''"
                      sortable
                    />
                    <el-table-column
                      :label="'Grid to EV'"
                      :prop="'grid_to_ev'"
                      :width="$vuetify.display.width <= 1810 ? 180 : ''"
                      sortable
                    />
                    <el-table-column
                      :label="'Solar to Grid'"
                      :prop="'solar_to_grid'"
                      :width="$vuetify.display.width <= 1810 ? 190 : ''"
                      sortable
                    />
                    <el-table-column
                      :label="'Battery to Grid'"
                      :prop="'battery_to_grid'"
                      :width="$vuetify.display.width <= 1810 ? 150 : ''"
                      sortable
                    />
                    <el-table-column
                      :label="'Battery to EV'"
                      :prop="'battery_to_ev'"
                      :width="$vuetify.display.width <= 1810 ? 180 : ''"
                      sortable
                    />
                    <el-table-column
                      :label="'Solar to EV'"
                      :prop="'solar_to_ev'"
                      :width="$vuetify.display.width <= 1810 ? 180 : ''"
                      sortable
                    />
                  </el-table>
                  </div>
                  <div class="d-flex justify-center">
                    <el-pagination
                      small
                      background
                      layout="prev, pager, next"
                      :total="total_items"
                      v-model:page-size="page_size"
                      v-model:current-page="current_page"
                      class="my-4"
                    />
                  </div>
                </div>
              </el-col>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="row m-0 starter-main" v-if="1 == 2" :class="$vuetify.display.width >= 1400 ? 'my-30' : $vuetify.display.width >= 768 ? 'my-30' : $vuetify.display.width >= 375 ? 'my-24' : 'my-20'">
      <div class="col-xl-12 xl-100 col-lg-12 box-col-12">
        <el-alert
          v-if="missingColumns.length > 0"
          @close="missingAlertCloseHandle"
          class="ma-2"
          title="file has a missing structure"
          type="error"
          show-icon
        >
          <p class="mb-0" style="color: #f56c6c">
            <template v-for="(miss) in missingColumns">
              {{ "The field " + miss + " is missing from the uploaded file. A value of zero will be applied to this field for all submitted records." }}
            </template>
          </p>
        </el-alert>
        <div class="card">
          <div class="card-body">
            <div class="tabbed-card session-tab">
              <div class="tab-content" id="pills-clrtabContentsuccess">
                <div
                  class="tab-pane fade show active"
                  id="pills-clrhomesuccess"
                  role="tabpanel"
                  aria-labelledby="pills-clrhome-tabsuccess"
                >
                  <el-upload
                    ref="upload"
                    class="upload-demo"
                    action="#"
                    :limit="1"
                    :auto-upload="false"
                    drag
                    :on-change="onChange"
                    :on-remove="onRemove"
                  >
                    <!-- <i class="fa fa-cloud-upload f-46"></i> -->
                    <svg class="stroke-icon width-40 height-35">
                      <use
                        href="@/assets/svg/icon-sprite.svg#drag-and-drop-icon-cloud"
                      ></use>
                    </svg>
                    <div class="el-upload__text text-white">
                      <em>Drop file here</em> or click to upload
                    </div>
                    <template #tip>
                      <div class="el-upload__tip">
                        Upload your Excel file
                      </div>
                    </template>
                  </el-upload>
                  <el-progress
                    v-if="hasLargeFile"
                    :percentage="sendingFilePercent"
                    stroke-width="10"
                    :format="progressFormat"
                    :status="sendingFilePercent == 100 ? 'success' : ''"
                  />
                  <el-alert
                    v-if="hasLargeFile && sendingFilePercent == 100"
                    title="Send Success"
                    :type="`success`"
                    class="mt-5"
                    show-icon
                  >
                    <p class="mb-0" style="color: #67c23a">
                      {{
                        "The file with a size of " +
                        sessionsFileSize +
                        " MB is received successfully. The result of this transaction, including valid and invalid sessions will be emailed to you shortly."
                      }}
                    </p>
                  </el-alert>

                  <el-steps
                    v-if="!hasLargeFile"
                    :active="activeStep"
                    finish-status="success"
                    :process-status="successStep"
                    simple
                    class="mb-4 mt-4"
                  >
                    <el-step title="Load Data" :description="stepLoadDesc" />
                    <el-step
                      @click="stepperChange(2)"
                      style="cursor: pointer"
                      title="Check Validate"
                      :description="stepValidDesc"
                    />
                    <el-step
                      @click="stepperChange(3)"
                      style="cursor: pointer"
                      title="Send Data"
                      :description="stepSendDesc"
                    />
                  </el-steps>

                  <Filter
                    v-if="!hasLargeFile"
                    @filterAction="filterAction"
                    @filterSearch="filterSearch"
                  />

                  <!-- <Stepper /> -->
                  <div class="ma-0" v-loading="loading" v-if="!hasLargeFile">
                    <el-alert
                      v-if="responseAlert.visible"
                      :title="responseAlert.title"
                      :type="responseAlert.type"
                      show-icon
                    >
                      <p
                        class="mb-0"
                        style="color: #67c23a"
                        v-if="response_alert.success_count > 0"
                      >
                        {{ responseAlert.success_desc }}
                      </p>
                      <p
                        class="mb-0"
                        style="color: #f56c6c"
                        v-if="response_alert.pending_count > 0"
                      >
                        {{ responseAlert.pending_desc }}
                      </p>
                      <p
                        class="mb-0"
                        style="color: #e6a23c"
                        v-if="response_alert.duplicate_count > 0"
                      >
                        {{ responseAlert.duplicate_desc }}
                      </p>
                    </el-alert>
                    <div class="custom-table-design">
                    <el-table
                      :data="filter_excel_data"
                      :fit="true"
                      height="50vh"
                      stripe
                      class="my-2"
                      :row-class-name="tableRowClassName"
                      @row-click="handleRowClick"
                      scrollbar-always-on
                    >
                      <el-table-column type="expand">
                        <template #default="props">
                          <div
                            class="pa-5"
                            v-if="
                              props.row.error_message != null &&
                              props.row.error_message.length > 0
                            "
                          >
                            <span class="text-red"> Attention : </span>
                            <p
                              m="t-0 b-2"
                              class="mb-0"
                              v-for="(error, i) in props.row.error_message"
                              :key="i"
                            >
                              {{ i + 1 + " : " + error }}
                            </p>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        :label="'Site Name'"
                        :prop="'site_name'"
                        :width="$vuetify.display.width <= 1810 ? 200 : ''"
                        sortable
                      />
                      <el-table-column
                        :label="'Postcode'"
                        :prop="'postcode'"
                        :width="$vuetify.display.width <= 1810 ? 150 : ''"
                        sortable
                      />
                      <el-table-column
                        :label="'Charger ID'"
                        :prop="'charger_id'"
                        :width="$vuetify.display.width <= 1810 ? 180 : ''"
                        sortable
                      />
                      <el-table-column
                        :label="'Charger Capacity (kW)'"
                        :prop="'charger_capacity_kW'"
                        :width="$vuetify.display.width <= 1810 ? 190 : ''"
                        sortable
                      />
                      <el-table-column
                        :label="'Port ID'"
                        :prop="'port_id'"
                        :width="$vuetify.display.width <= 1810 ? 150 : ''"
                        sortable
                      />
                      <el-table-column
                        :label="'Start Time'"
                        :prop="'start_time'"
                        :width="$vuetify.display.width <= 1810 ? 180 : ''"
                        sortable
                      />
                      <el-table-column
                        :label="'End Time'"
                        :prop="'end_time'"
                        :width="$vuetify.display.width <= 1810 ? 180 : ''"
                        sortable
                      />
                      <el-table-column
                        :label="'Usage (kWh)'"
                        :prop="'usage_kWh'"
                        :width="$vuetify.display.width <= 1810 ? 150 : ''"
                        sortable
                      />
                    </el-table>
                    </div>
                    <div class="d-flex justify-center">
                      <el-pagination
                        small
                        background
                        layout="prev, pager, next"
                        :total="total_items"
                        v-model:page-size="page_size"
                        v-model:current-page="current_page"
                        class="my-4"
                      />
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="pills-clrprofilesuccess"
                  role="tabpanel"
                  aria-labelledby="pills-clrprofile-tabsuccess"
                  :class="$vuetify.display.width >= 1400 ? 'mt-30' : $vuetify.display.width >= 768 ? 'mt-30' : $vuetify.display.width >= 375 ? 'mt-24' : 'mt-20'"
                >
                  <SimpleUpload />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Breadcrumbs from "../../../components/bread_crumbs.vue";
import XLSX from "xlsx";
import UserService from "../../../services/user.service";
import { useToast } from "vue-toastification";
import { ElMessageBox } from "element-plus";
import moment from "moment";
import { addTaskIdtoSessionStorage, createCeleryTaskPoller } from "../../dashboard/common/pollingCeleryTask";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "onsite-renewables",
  components: {
    Breadcrumbs,
  },
  data() {
    return {
      breadcrumbPath: [
        {
          title: "Operation",
          disabled: true,
          href: "",
        },
        {
          title: "OnSite Renewables (BESS)",
          disabled: false,
          href: "/upload-onsite-renewables",
          active: true,
        },
      ],
      uploadFilter: "1",
      show: true,
      selectedFile: null,
      fileList: [],
      excelDataList: [],
      search: "",
      current_page: 1,
      page_size: 100,
      total_items: 100,
      excelData: [],
      beforeUploadValid: true,
      dupRowIndex: [],
      invalidRowIndex: [],
      data: null,
      activeStep: 0,
      successStep: "wait",
      loading: false,
      register_serial_id: "",
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      fromDate: "",
      toDate: "",
      statusRow: 1,
      filter: {
        fromDate: "",
        toDate: "",
        statusRow: 1,
      },
      hasResponse: true,
      response_alert: {
        all_rows_count: 0,
        success_count: 0,
        success_sum_kwh: 0,
        pending_count: 0,
        pending_sum_kwh: 0,
        error_count: 0,
        error_sum_kwh: 0,
        duplicate_count: 0,
      },
      correctFile: true,
      alertWrongFile: false,
      responseAlert: {
        visible: false,
        title: "",
        type: "info",
        success_desc: "",
        pending_desc: "",
        duplicate_desc: "",
      },
      customerList: [],
      customerId: null,
      removeInvalidRow: false,
      missingColumns: [],
      showMissingColumns: false,
      missingOptionalColumns: [],
      fileUpload: null,
      rows: [],
      isLoading: false,
      dataLoaded: false,
      currentRow: 0,
      sessionsFileSize: 0,
      hasLargeFile: false,
      sendingFilePercent: 0,
      taskId: null,
      pollingInterval: null,
      taskStatus: null,
    };
  },
  created() {
    this.fetchCustomerData();
  },
  watch: {
    search() {
      this.current_page = 1;
    },
    correctFile(new_val) {
      if (!new_val) {
        this.alertWrongFile = true;
        if (this.$refs.upload) this.$refs.upload.clearFiles();
      } else {
        this.alertWrongFile = false;
      }
    },

    missingColumns: {
      handler: function(new_val) {
        if (new_val.length > 0) {
          this.showMissingColumns = true;
        } else {
          this.showMissingColumns = false;
        }
      },
      deep: true,
      immediate: true,
    }

  },
  computed: {
    filter_excel_data() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties, no-unused-vars
      let list = this.excelDataList.filter((item, index) => {
        var validSDate = this.isValidDate(item.start_time);
        var validEDate = this.isValidDate(item.end_time);
        if (!validSDate && item.start_time != null) {
          let start_milliseconds = (item.start_time - 25569) * 86400 * 1000;
          if (start_milliseconds != null && start_milliseconds != undefined) {
            item.start_time = moment
              .utc(start_milliseconds)
              .format("YYYY/MM/DD HH:mm:ss");
          }
        }
        if (!validEDate && item.end_time != null) {
          let end_milliseconds = (item.end_time - 25569) * 86400 * 1000;
          if (end_milliseconds != null && end_milliseconds != undefined) {
            item.end_time = moment
              .utc(end_milliseconds)
              .format("YYYY/MM/DD HH:mm:ss");
          }
        }
        //item.register_id = this.register_serial_id;
        //item.customer_id = this.$store.state.auth.user.id;
        return (
          ((item.site_name === undefined || item.site_name == null
            ? ""
            : item.site_name
          )
            .toString()
            .toLowerCase()
            .indexOf(this.search.toLowerCase()) > -1 ||
            (item.charger_id === undefined || item.charger_id == null
              ? ""
              : item.charger_id
            )
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1 ||
            (item.port_id === undefined || item.port_id == null
              ? ""
              : item.port_id
            )
              .toString()
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1) &&
          (validSDate &&
          validEDate &&
          this.isValidDate(this.fromDate) &&
          this.isValidDate(this.toDate)
            ? new Date(item.start_time) >= new Date(this.fromDate) &&
              new Date(item.start_time) <= new Date(this.toDate) &&
              new Date(item.end_time) >= new Date(this.fromDate) &&
              new Date(item.end_time) <= new Date(this.toDate)
            : true) &&
          (this.statusRow == 1 ||
            (this.statusRow == 2 &&
              item.is_duplicate) /*this.dupRowIndex.includes(index)) ||*/ ||
            (this.statusRow == 3 &&
              Object.keys(item).includes("error_message") &&
              item.error_message.length > 0))
        );
      });
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.total_items = list.length;
      let paginated = this.paginate(list, this.page_size, this.current_page);
      return paginated;
    },
  },
  methods: {
    // Fetch customer data for admin users
    async fetchCustomerData() {
      this.loading = true;
      await UserService.getCustomers(null)
        .then(
          (response) => {
            if (!response || !response.data || !response.data.customers) {
              this.customers = [];
            } else {
              this.customerList = response.data.customers;
            }
          },
          (error) => {
            this.loading = false;
            console.log(error.message);
            if (error.response && error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error.message);
          if (error.response && error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    onChange(event) {
      // Clear previous data before processing new file
      this.clearPreviousData();
      
      this.loading = true;
      this.successStep = "process";
      const file = event.raw ? event.raw : null;
      this.fileUpload = file;
      this.sessionsFileSize = file.size / 1024 / 1024;
      if (
        file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&
        file.type !== "application/vnd.ms-excel"
      ) {
        this.loading = false;
        this.successStep = "wait";
        this.$message.error(`select an Excel format!`);
        this.fileList = [];
        // Clear the file from upload component
        this.$nextTick(() => {
          if (this.$refs.uploadMain) this.$refs.uploadMain.clearFiles();
          if (this.$refs.upload) this.$refs.upload.clearFiles();
        });
      } else if (file) {
        this.selectedFile = event.raw;
        this.fileList = [event];
        this.importExcel(this.sessionsFileSize);
      }
    },
    clearPreviousData() {
      this.selectedFile = null;
      this.fileList = [];
      this.excelDataList = [];
      this.excelData = [];
      this.removeInvalidRow = false;
      this.activeStep = 0;
      this.successStep = "wait";
      this.loading = false;
      this.hasLargeFile = false;
      this.sendingFilePercent = 0;
      this.sessionsFileSize = 0;
      this.response_alert = {
        all_rows_count: 0,
        success_count: 0,
        success_sum_kwh: 0,
        pending_count: 0,
        pending_sum_kwh: 0,
        error_count: 0,
        error_sum_kwh: 0,
        duplicate_count: 0,
      };
      this.correctFile = true;
      this.responseAlert = {
        visible: false,
        title: "",
        type: "info",
        success_desc: "",
        pending_desc: "",
        duplicate_desc: "",
      };
      this.missingColumns = [];
      this.dupRowIndex = [];
      this.invalidRowIndex = [];
      this.current_page = 1;
      this.search = "";
      this.taskId = null;
      this.taskStatus = null;
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },

    // eslint-disable-next-line no-unused-vars
    onRemove(event, fileList) {
      this.clearPreviousData();
    },

    handleExceed(files) {
      this.$message.warning(`Only one file can be uploaded at a time. Replacing the existing file.`);
      if (this.$refs.uploadMain) {
        this.$refs.uploadMain.clearFiles();
        this.$refs.uploadMain.handleStart(files[0]);
      } else if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
        this.$refs.upload.handleStart(files[0]);
      }
    },

    async reader() {
      this.missingColumns = [];
      this.missingOptionalColumns = [];
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const headers = [];
        for (let cell in worksheet) {
          const col = cell.substring(0, 1);
          if (cell[0] === '!' || !worksheet[cell].v) continue;
          if (cell.replace(/\d/g, '') === col && parseInt(cell.replace(/\D/g, '')) === 1) {
            headers[cell[0].charCodeAt(0) - 65] = worksheet[cell].v.toString().trim();
          }
        }

        // Convert sheet to JSON with raw values and date handling
        this.excelData = XLSX.utils.sheet_to_json(worksheet, {
          defval: 0,
          raw: false, // Get formatted strings instead of raw values
          dateNF: 'yyyy-mm-dd hh:mm:ss', // Format for date strings
          cellDates: true // Parse dates
        });
        
        // Process date columns to ensure consistent format
        this.excelData = this.excelData.map(row => {
          const newRow = { ...row };
          // Check each cell that might contain a date
          Object.keys(newRow).forEach(key => {
            if (newRow[key] instanceof Date) {
              // Format the date as a string in the desired format
              newRow[key] = moment(newRow[key]).format('YYYY-MM-DD HH:mm:ss');
            } else if (typeof newRow[key] === 'number' && headers.includes('time') && key === 'time') {
              // Handle Excel date serial numbers for the time column
              const date = XLSX.SSF.parse_date_code(newRow[key]);
              const datetime = new Date(0, 0, 0, 0, 0, 0);
              datetime.setFullYear(date.y, date.m - 1, date.d);
              datetime.setHours(date.H, date.M, date.S);
              newRow[key] = moment(datetime).format('YYYY-MM-DD HH:mm:ss');
            }
          });
          return newRow;
        });
        // const headers = [];
        // for (let cell in worksheet) {
        //   if (cell !== "!ref" && cell[1] === "1") {
        //     headers.push(worksheet[cell].v);
        //   }
        // }
        const requiredColumns = [
          "time",
          "site_name",
        ];
        const optionalColumns = [
          "grid_to_ev",
          "solar_to_grid",
          "battery_to_grid",
          "battery_to_ev",
          "solar_to_ev",
        ];
        
        // Check for missing required columns
        this.missingColumns = requiredColumns.filter(
          (column) => !headers.includes(column)
        );
        
        // Check for missing optional columns (for display purposes)
        const missingOptionalColumns = optionalColumns.filter(
          (column) => !headers.includes(column)
        );
        this.missingOptionalColumns = missingOptionalColumns;
        
        console.log(missingOptionalColumns);
        
        
        // If required columns are missing, show error
        if (this.missingColumns.length > 0) {
          this.excelDataList = [];
          this.activeStep = 0;
          this.correctFile = false;
          this.loading = false;
          // this.successStep = "error";
          // if (this.$refs.uploadMain) this.$refs.uploadMain.clearFiles();
          // if (this.$refs.upload) this.$refs.upload.clearFiles();
          return;
        } else {
          this.missingColumns = [];
          this.showMissingColumns = false;
          this.correctFile = true;
        }
        
        // Add default values for missing optional columns
        this.excelData = this.excelData.map(row => {
          const newRow = { ...row };
          optionalColumns.forEach(col => {
            if (!(col in newRow)) {
              newRow[col] = 0;
            }
          });
          return newRow;
        });
        
        this.excelDataList = this.excelData;
        this.register_serial_id = btoa(
          this.$store.state.auth.user.id.toString() +
            "-" +
            this.excelDataList.length.toString() +
            "-" +
            Date.now().toString()
        );
        this.loading = false;
      };
      reader.readAsArrayBuffer(this.selectedFile);
      // console.log(4, Date.now().toString());
      this.activeStep = 1;
    },

    handleUpload() {
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const range = XLSX.utils.decode_range(sheet["!ref"]);
        console.log(range);

        for (
          let i = this.currentRow;
          i < Math.min(this.currentRow + 10, range.e.r + 1);
          i++
        ) {
          const row = {};
          for (let j = range.s.c; j <= range.e.c; j++) {
            const cellAddress = { c: j, r: i };
            const cellRef = XLSX.utils.encode_cell(cellAddress);
            const cellValue = sheet[cellRef] ? sheet[cellRef].v : null;
            row[`col_${j}`] = cellValue;
          }
          this.rows.push(row);
        }
        console.log(this.rows);
        this.currentRow += 10;
      };
      // console.log(this.rows);
      reader.readAsArrayBuffer(this.fileUpload);
    },

    async importExcel(fileSize) {
      if (this.selectedFile) {
        // await this.handleUpload();
        // console.log(fileSize);
        if (fileSize <= 5) {
          this.hasLargeFile = false;
          await this.reader();
        } else {
          this.hasLargeFile = true;
          await this.handleFileUpload(this.fileUpload);
        }
      } else {
        this.successStep = "error";
        this.$message.error("Please select an Excel file first.");
        this.loading = false;
      }
      this.response_alert = {
        success_count: 0,
        success_sum_kwh: 0,
        pending_count: 0,
        pending_sum_kwh: 0,
        error_count: 0,
        error_sum_kwh: 0,
        duplicate_count: 0,
      };
    },

    progressFormat() {
      return this.sendingFilePercent == 100
        ? "Sent"
        : this.sendingFilePercent.toString() + "%";
    },

    async handleFileUpload(event) {
      const file = event;
      this.sendingFilePercent = 0;
      
      try {
        // Parse the Excel file
        const data = await this.readFileAsArrayBuffer(file);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        
        // Get headers
        const headers = [];
        for (let cell in worksheet) {
          const col = cell.substring(0, 1);
          if (cell[0] === '!' || !worksheet[cell].v) continue;
          if (cell.replace(/\d/g, '') === col && parseInt(cell.replace(/\D/g, '')) === 1) {
            headers[cell[0].charCodeAt(0) - 65] = worksheet[cell].v.toString().trim();
          }
        }
        
        // Check for required columns
        const requiredColumns = ["time", "site_name"];
        const optionalColumns = ["grid_to_ev", "solar_to_grid", "battery_to_grid", "battery_to_ev", "solar_to_ev"];
        const missingRequired = requiredColumns.filter(column => !headers.includes(column));
        
        if (missingRequired.length > 0) {
          this.missingColumns = missingRequired;
          this.showMissingColumns = true;
          this.loading = false;
          return;
        }
        
        this.sendingFilePercent = 20;
        
        // Convert sheet to JSON
        let excelData = XLSX.utils.sheet_to_json(worksheet, {
          defval: 0,
          raw: false,
          dateNF: 'yyyy-mm-dd hh:mm:ss',
          cellDates: true
        });
        
        this.sendingFilePercent = 40;
        
        // Process date columns
        excelData = excelData.map(row => {
          const newRow = { ...row };
          Object.keys(newRow).forEach(key => {
            if (newRow[key] instanceof Date) {
              newRow[key] = moment(newRow[key]).format('YYYY-MM-DD HH:mm:ss');
            } else if (typeof newRow[key] === 'number' && key === 'time') {
              const date = XLSX.SSF.parse_date_code(newRow[key]);
              const datetime = new Date(0, 0, 0, 0, 0, 0);
              datetime.setFullYear(date.y, date.m - 1, date.d);
              datetime.setHours(date.H, date.M, date.S);
              newRow[key] = moment(datetime).format('YYYY-MM-DD HH:mm:ss');
            }
          });
          // Add default values for missing optional columns
          optionalColumns.forEach(col => {
            if (!(col in newRow)) {
              newRow[col] = 0;
            }
          });
          return newRow;
        });
        
        this.sendingFilePercent = 60;
        
        // Send data to the correct endpoint
        const response = await UserService.setOnSiteRenewables(excelData, this.customerId);
        
        this.sendingFilePercent = 80;
        
        if (response.data && response.data.task_id) {
          this.taskId = response.data.task_id;
          this.activeStep = 3;
          
          addTaskIdtoSessionStorage('onsite_renewables_upload', this.taskId, 'PENDING', "hasInvalidRecords", {
            response_alert: this.response_alert,
            responseAlert: this.responseAlert,
          });
          
          const poller = createCeleryTaskPoller(this.taskId, 30000, 'onsite_renewables_upload');
          poller.startPolling();
          
          this.sendingFilePercent = 100;
          
          useToast().info(
            "File uploaded successfully. Processing your data...",
            {
              icon: "fa fa-info-circle",
              position: "bottom-right",
              timeout: 3000,
            }
          );
        } else {
          throw new Error("No task_id received from server");
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
        if (error.response && error.response.status == 401) {
          this.$router.push({ path: "/" });
        }
        useToast().error("Error processing file. Please check the file format and try again.", {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 2000,
        });
      } finally {
        this.loading = false;
      }
    },
    
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(new Uint8Array(e.target.result));
        reader.onerror = (e) => reject(e);
        reader.readAsArrayBuffer(file);
      });
    },

    checkDuplicateRow(arrayData) {
      let user = this.$store.state.auth.user;
      this.successStep = "process";
      let uniqueObjects = new Map();
      let ctx = this;
      let validateStatus = true;
      this.dupRowIndex = [];
      this.invalidRowIndex = [];
      arrayData.forEach((obj, i) => {
        var key = `${obj.site_name}-${obj.time}-${obj.grid_to_ev}-${obj.solar_to_grid}-${obj.battery_to_grid}-${obj.battery_to_ev}-${obj.solar_to_ev}`;
        obj.error_message = null;
        if (uniqueObjects.has(key)) {
          ctx.dupRowIndex.push(i);
          obj.is_duplicate = true;
        } else {
          uniqueObjects.set(key, obj);
        }
        obj.register_id = this.register_serial_id;
        obj.customer_id = user.id;
        obj.error_message = ctx.validateData(obj);
        if (validateStatus && obj.error_message.length > 0) {
          validateStatus = false;
        }
      });
      if (validateStatus) {
        this.activeStep = 2;
        this.successStep = "process";
      } else {
        this.successStep = "error";
        this.removeInvalidRow = false;
        ElMessageBox.confirm(
          "Do you want to send rows without errors?",
          "confirm",
          {
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            type: "Confirm Delete",
          }
        )
          .then(() => {
            this.removeInvalidRow = true;
            this.activeStep = 2;
            this.stepperChange(3);
          })
          .catch(() => {
            this.successStep = "error";
            this.removeInvalidRow = false;
          });
      }
    },

    validateData(item) {
      var error = [];
      // title
      if (item.site_name == null) {
        error.push("Site can not be null or empty.");
      }

      if (item.time == null) {
        error.push("Time can not be null or empty.");
      }
      if (
        item.time != null &&
        item.time != "" &&
        !this.isValidDate(item.time)
      ) {
        error.push("Time is invalid.");
      }

      return error;
    },

    validateAfterSend(
      keyDup,
      keyInvalidSite,
      keyInvalidCharger,
      keyInvalidPort,
      keyInvalidCapacity,
      keyInvalidPostcode,
      keyInvalidAboveCapacity
    ) {
      let validateStatus = true;
      this.dupRowIndex = [];
      this.response_alert.all_rows_count = this.excelDataList.length;
      this.response_alert.success_count = 0;
      this.response_alert.success_sum_kwh = 0;
      this.response_alert.pending_count = 0;
      this.response_alert.pending_sum_kwh = 0;
      this.response_alert.error_count = 0;
      this.response_alert.error_sum_kwh = 0;
      this.response_alert.duplicate_count = 0;
      this.excelDataList.forEach((obj) => {
        let obj_site_name =
          obj.site_name == null || obj.site_name == undefined
            ? ""
            : obj.site_name.toString().toUpperCase();
        let obj_charger_id =
          obj.charger_id == null || obj.charger_id == undefined
            ? ""
            : obj.charger_id.toString().toUpperCase();
        let obj_port_id =
          obj.port_id == null || obj.port_id == undefined
            ? ""
            : obj.port_id.toString().toUpperCase();
        // console.log(obj);
        // console.log(`${obj_site_name};${obj_charger_id};${obj.postcode}`);
        // console.log(
        //   `${obj_site_name};${obj_charger_id};${obj.charger_capacity_kW}`
        // );
        // console.log(
        //   `${obj_site_name};${obj_charger_id};${obj_port_id};${obj.usage_kWh}`
        // );
        // keyDup
        if (
          keyDup != "" &&
          keyDup
            .split(",")
            .includes(
              `${obj_site_name};${obj_charger_id};${
                obj_port_id === undefined ? "null" : obj_port_id
              };${obj.usage_kWh}`
            )
        ) {
          this.response_alert.duplicate_count += 1;
          obj.error_message.push("dup");
          // obj.error_message.push(
          //   "The session with this information already exist in the database"
          // );
        }
        // keyInvalidSite
        if (
          keyInvalidSite != "" &&
          keyInvalidSite.split(",").includes(`${obj_site_name}`)
        ) {
          obj.error_message.push("invalid site");
        }
        // keyInvalidCharger
        if (
          keyInvalidCharger != "" &&
          keyInvalidCharger
            .split(",")
            .includes(`${obj_site_name};${obj_charger_id}`)
        ) {
          obj.error_message.push("invalid charger");
        }
        // keyInvalidPort
        if (
          keyInvalidPort != "" &&
          keyInvalidPort
            .split(",")
            .includes(`${obj_site_name};${obj_charger_id};${obj_port_id}`)
        ) {
          obj.error_message.push("invalid port id");
        }
        // keyInvalidCapacity
        if (
          keyInvalidCapacity != "" &&
          keyInvalidCapacity
            .split(",")
            .includes(
              `${obj_site_name};${obj_charger_id};${obj.charger_capacity_kW}`
            )
        ) {
          obj.error_message.push("charger capacity mismatch");
        }
        // keyInvalidPostcode
        if (
          keyInvalidPostcode != "" &&
          keyInvalidPostcode
            .split(",")
            .includes(`${obj_site_name};${obj_charger_id};${obj.postcode}`)
        ) {
          obj.error_message.push("charger postcode mismatch");
        }
        // keyInvalidAboveCapacity
        if (
          keyInvalidAboveCapacity != "" &&
          keyInvalidAboveCapacity
            .split(",")
            .includes(
              `${obj_site_name};${obj_charger_id};${obj_port_id};${obj.usage_kWh}`
            )
        ) {
          obj.error_message.push(
            "the power drown during the charging session is above 1.05 * charger capacity."
          );
        }
        if (validateStatus && obj.error_message.length > 0) {
          validateStatus = false;
        }
      });

      // this.excelDataList = this.excelDataList.filter(
      //   (item) => item.error_message.length != 0
      // );

      let successCount = this.excelDataList.filter(
        (item) => item.error_message.length == 0
      );
      for (const item of successCount) {
        this.response_alert.success_count += 1;
        this.response_alert.success_sum_kwh += item.usage_kWh;
      }
      this.excelDataList = this.excelDataList.filter(
        (item) =>
          item.error_message.length != 0 && item.error_message[0] != "dup"
      );
      for (const item of this.excelDataList) {
        this.response_alert.error_count += 1;
        this.response_alert.error_sum_kwh += item.usage_kWh;
      }
      return validateStatus;
    },

    // eslint-disable-next-line no-unused-vars
    tableRowClassName({ row, rowIndex }) {
      // if (this.dupRowIndex.includes(rowIndex)) {
      if (row.is_duplicate) {
        return "warning-row";
      } else if (
        Object.keys(row).includes("error_message") &&
        row.error_message.length > 0
      ) {
        return "error-row";
      }
      return "";
    },

    isValidDate(dateString) {
      // Handle both YYYY-MM-DD and YYYY/MM/DD formats
      const dateRegex = new RegExp('^(\\d{4})[/-](\\d{2})[/-](\\d{2}) (\\d{2}):(\\d{2}):(\\d{2})$');
      if (dateRegex.test(dateString)) {
        // Normalize the date string to YYYY-MM-DD format for better Date parsing
        const normalizedDate = dateString.replace(/\//g, '-');
        const date = new Date(normalizedDate);
        return !isNaN(date.getTime());
      }
      return false;
    },

    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },

    stepperChange(num) {
      console.log('stepperChange', num, this.excelDataList.length);
      if (num == 2 && this.excelDataList.length > 0 && this.activeStep == 1) {
        // console.log(this.excelDataList);
        this.checkDuplicateRow(this.excelDataList);
      } else if (
        num == 3 &&
        this.excelDataList.length > 0 &&
        this.activeStep == 2
      ) {

        //var jsonDate = JSON.stringify(this.excelDataList);
        //console.log(jsonDate);
        console.log(moment(new Date()).format("HH:mm:ss"));
        this.sendDate(this.excelDataList);
      }
    },

    sendDate(jsonData) {
      this.loading = true;
      jsonData = jsonData.filter((item) => {
        // if (this.removeInvalidRow) {
        return (
          !item.is_duplicate &&
          (item.error_message == null || item.error_message.length == 0)
        );
        // }
      });
      if (jsonData.length == 0) {
        this.loading = false;
        useToast().error(" All rows have errors. There is no row to send.", {
          icon: "fa fa-times",
          position: "bottom-right",
          timeout: 2000,
        });
      } else {
        // console.log(jsonData);
        UserService.setOnSiteRenewables(jsonData, this.customerId)
          .then(
            (response) => {
              console.log(moment(new Date()).format("HH:mm:ss"));
              console.log("API Response:", response);
              
              // Get task_id from response
              if (response.data && response.data.task_id) {
                this.taskId = response.data.task_id;
                this.excelDataList = [];
                this.activeStep = 3;
                
                // // Dispatch action to start processing indicator
                // this.$store.dispatch('renewableProcessing/startRenewableProcessing', this.taskId);
                
                // useToast().info(
                //   "File uploaded successfully. Processing your data...",
                //   {
                //     icon: "fa fa-info-circle",
                //     position: "bottom-right",
                //     timeout: 3000,
                //   }
                // );
                
                // // Start polling for task status
                // this.startPollingTaskStatus();

                addTaskIdtoSessionStorage('onsite_renewables_upload', this.taskId, 'PENDING', "hasInvalidRecords", {
                  response_alert: this.response_alert,
                  responseAlert: this.responseAlert,
                });

                const poller = createCeleryTaskPoller(this.taskId, 30000, 'onsite_renewables_upload');

                poller.startPolling();

                useToast().info(
                  "File uploaded successfully. Processing your data...",
                  {
                    icon: "fa fa-info-circle",
                    position: "bottom-right",
                    timeout: 3000,
                  }
                );


              } else {
                throw new Error("No task_id received from server");
              }
              // if (response.data.data.duplicate != null) {
              //   duplicate = response.data.data.duplicate;
              // }
              // if (response.data.data.invalid_charger_id != null) {
              //   invalid_charger_data = response.data.data.invalid_charger_id;
              // }
              // if (response.data.data.invalid_port_id != null) {
              //   invalid_port_data = response.data.data.invalid_port_id;
              // }
              // if (response.data.data.invalid_site_title != null) {
              //   invalid_site_data = response.data.data.invalid_site_title;
              // }
              // if (response.data.data.invalid_capacity != null) {
              //   invalid_capacity_data = response.data.data.invalid_capacity;
              // }
              // if (response.data.data.invalid_postcode != null) {
              //   invalid_postcode_data = response.data.data.invalid_postcode;
              // }
              // if (response.data.data.invalid_above_capacity != null) {
              //   invalid_above_capacity_data =
              //     response.data.data.invalid_above_capacity;
              // }

              // this.response_alert.pending_count =
              //   response.data.data.pending_count;
              // this.response_alert.pending_sum_kwh =
              //   response.data.data.pending_sum_kwh;
              // let isValid = this.validateAfterSend(
              //   duplicate,
              //   invalid_site_data,
              //   invalid_charger_data,
              //   invalid_port_data,
              //   invalid_capacity_data,
              //   invalid_postcode_data,
              //   invalid_above_capacity_data
              // );
              // // console.log(this.response_alert);
              // if (isValid) {
              //   this.activeStep = 3;
              //   useToast().success(" Send session file successfully ", {
              //     icon: "fa fa-check",
              //     position: "bottom-right",
              //     timeout: 2000,
              //   });
              // } else {
              //   this.activeStep = 1;
              //   this.successStep = "error";
              //   useToast().error(
              //     " Please check the details for each item sent.",
              //     {
              //       icon: "fa fa-times",
              //       position: "bottom-right",
              //       timeout: 2000,
              //     }
              //   );
              // }

              // this.responseAlert.visible = true;
              // // this.responseAlert.type = "info";
              // this.responseAlert.title = `From the ${this.response_alert.all_rows_count} rows sent in the Excel file`;
              // this.responseAlert.success_desc =
              //   `Success : ` +
              //   `${this.response_alert.success_count} records with ${this.response_alert.success_sum_kwh} kWh were registered successfully.`;
              // this.responseAlert.pending_desc =
              //   `Pending : ` +
              //   `${this.response_alert.pending_count} records with ${this.response_alert.pending_sum_kwh} kwh have errors and were considered pending.`;
              // this.responseAlert.duplicate_desc =
              //   `Duplicate : ` +
              //   `${this.response_alert.duplicate_count} records were already in the database, and are not inserted again.`;
              // // console.log(this.response_alert);
              // // console.log(this.responseAlert);
            },
            (error) => {
              this.loading = false;
              console.log(error);
              if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
              useToast().error(
                " Please check the details for each item sent.",
                {
                  icon: "fa fa-times",
                  position: "bottom-right",
                  timeout: 2000,
                }
              );
            }
          )
          .catch((error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
            useToast().error(" Please check the details for each item sent.", {
              icon: "fa fa-times",
              position: "bottom-right",
              timeout: 2000,
            });
          })
          .finally(() => (this.loading = false));
      }
    },

    // eslint-disable-next-line no-unused-vars
    handleRowClick(row, column, event) {
      console.log(row, column, event);
      // this.$notify.error({
      //   title: "Validate Error",
      //   message: "",
      //   showClose: false,
      // });
    },

    handlePerv() {
      if (this.activeStep == 1 && this.successStep == "error") {
        this.activeStep = 1;
        // this.successStep = "process";
        this.stepperChange(2);
      } else if (this.activeStep == 2) {
        this.activeStep = 1;
        this.successStep = "process";
      } else if (this.activeStep == 3) {
        this.stepperChange(2);
      }
    },

    handleNext() {
      if (this.activeStep == 1) {
        this.stepperChange(2);
      } else if (this.activeStep == 2 && this.successStep == "process") {
        this.stepperChange(3);
      }
    },

    current_change_click() {},

    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },

    filterAction(event) {
      if (event.kind == "refresh") {
        this.refresh_filter(event);
      } else if (event.kind == "reset") {
        this.reset_filter(event);
      } else if (event.kind == "excel") {
        this.handleExportFile();
      } else if (event.kind == "prev") {
        this.handlePerv();
      } else if (event.kind == "next") {
        this.handleNext();
      }
    },

    filterSearch(event) {
      this.search = event.search;
    },

    refresh_filter(event) {
      this.filter = event.filter;
      this.current_page = 1;
      this.fromDate = this.filter.fromDate;
      this.toDate = this.filter.toDate;
      this.search = this.filter.search;
      this.statusRow = this.filter.statusRow;
      console.log(this.filter);
    },

    reset_filter(event) {
      this.current_page = 1;
      this.fromDate = "";
      this.toDate = "";
      this.search = "";
      this.statusRow = 1;
      this.filter = event.filter;
    },

    handleExportFile() {
      if (this.excelDataList.length > 0) {
        let modifiedArr = this.excelDataList.map((item) => {
          let {
            // eslint-disable-next-line no-unused-vars
            error_message,
            // eslint-disable-next-line no-unused-vars
            register_id,
            // eslint-disable-next-line no-unused-vars
            customer_id,
            // eslint-disable-next-line no-unused-vars
            is_duplicate,
            ...rest
          } = item;
          return rest;
        });
        const ws = XLSX.utils.json_to_sheet(modifiedArr, {
          header: Object.keys(modifiedArr[0]),
        });
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Data");
        XLSX.writeFileXLSX(wb, "SessionList.xlsx");
      }
    },

    missingAlertCloseHandle() {
      this.alertWrongFile = false;
      this.missingColumns = [];
      this.missingOptionalColumns = [];
      this.onRemove();
    },
    
    startPollingTaskStatus() {
      // Poll every 30 seconds
      this.pollingInterval = setInterval(() => {
        this.checkTaskStatus();
      }, 30000);
      
      // Also check immediately
      this.checkTaskStatus();
    },
    
    checkTaskStatus() {
      if (!this.taskId) return;
      
      UserService.checkCeleryTaskStatus(this.taskId)
        .then((response) => {
          console.log("Task status response:", response);
          
          if (response.data && response.data.status) {
            this.taskStatus = response.data.status;
            
            // Update processing status in store
            this.$store.dispatch('renewableProcessing/updateProcessingStatus', response.data.status);
            
            switch (response.data.status.toUpperCase()) {
              case 'SUCCESS':
                this.handleTaskSuccess(response.data);
                break;
              case 'FAILURE':
                this.handleTaskFailure(response.data);
                break;
              case 'PENDING':
              case 'STARTED':
              case 'RETRY':
                // Continue polling
                console.log(`Task ${this.taskId} is ${response.data.status}`);
                break;
              default:
                console.log(`Unknown task status: ${response.data.status}`);
            }
          }
        })
        .catch((error) => {
          console.error("Error checking task status:", error);
          if (error.response && error.response.status === 404) {
            // Task not found, stop polling
            this.stopPolling();
            useToast().error("Task not found. Please try uploading again.", {
              icon: "fa fa-times",
              position: "bottom-right",
              timeout: 3000,
            });
          }
        });
    },
    
    handleTaskSuccess(data) {
      this.stopPolling();
      this.loading = false;
      
      // Complete the processing state in store
      this.$store.dispatch('renewableProcessing/completeRenewableProcessing');
      
      // Check if we have result data
      if (data.result) {
        const result = data.result;
        let message = "File processed successfully!";
        
        // Build detailed message with results
        if (result.valid_count !== undefined || result.invalid_count !== undefined) {
          const parts = ["File processed successfully!"];
          
          if (result.valid_count !== undefined) {
            parts.push(`✓ Valid records: ${result.valid_count}`);
          }
          
          if (result.invalid_count !== undefined) {
            parts.push(`✗ Invalid records: ${result.invalid_count}`);
            
            // Add details about invalid records if available
            if (result.invalid_records && Array.isArray(result.invalid_records) && result.invalid_records.length > 0) {
              // Show first few error examples
              const maxErrors = 3;
              const errorCount = result.invalid_records.length;
              
              if (errorCount <= maxErrors) {
                result.invalid_records.forEach((record) => {
                  if (record.error || record.reason) {
                    parts.push(`  • ${record.error || record.reason}`);
                  }
                });
              } else {
                result.invalid_records.slice(0, maxErrors).forEach((record) => {
                  if (record.error || record.reason) {
                    parts.push(`  • ${record.error || record.reason}`);
                  }
                });
                parts.push(`  • ... and ${errorCount - maxErrors} more errors`);
              }
            }
          }
          
          message = parts.join('\n');
        }
        
        // Use appropriate toast type based on results
        const hasInvalidRecords = result.invalid_count > 0;
        const toastMethod = hasInvalidRecords ? useToast().warning : useToast().success;
        
        toastMethod(message, {
          icon: hasInvalidRecords ? "fa fa-exclamation-triangle" : "fa fa-check",
          position: "bottom-right",
          timeout: hasInvalidRecords ? 8000 : 5000, // Longer timeout if there are errors to read
        });
        
        // Update the response alert if needed
        if (result.valid_count !== undefined || result.invalid_count !== undefined) {
          this.response_alert.success_count = result.valid_count || 0;
          this.response_alert.error_count = result.invalid_count || 0;
          
          this.responseAlert.visible = true;
          this.responseAlert.type = hasInvalidRecords ? "warning" : "success";
          this.responseAlert.title = `Processing complete`;
          this.responseAlert.success_desc = result.valid_count > 0 
            ? `${result.valid_count} records processed successfully.` 
            : "";
          this.responseAlert.pending_desc = result.invalid_count > 0 
            ? `${result.invalid_count} records had errors and were not processed.` 
            : "";
        }
      } else {
        // Fallback to simple success message if no result data
        useToast().success(
          "File processed successfully! The results will be emailed to you.",
          {
            icon: "fa fa-check",
            position: "bottom-right",
            timeout: 3000,
          }
        );
      }
      
      // Clear the upload
      this.onRemove();
      if (this.$refs.uploadMain) this.$refs.uploadMain.clearFiles();
      if (this.$refs.upload) this.$refs.upload.clearFiles();
    },
    
    handleTaskFailure(data) {
      this.stopPolling();
      this.loading = false;
      
      // Fail the processing state in store
      this.$store.dispatch('renewableProcessing/failRenewableProcessing');
      
      const errorMessage = data.result || "An error occurred while processing your file.";
      useToast().error(errorMessage, {
        icon: "fa fa-times",
        position: "bottom-right",
        timeout: 5000,
      });
      
      // Reset to allow retry
      this.activeStep = 1;
      this.successStep = "error";
    },
    
    stopPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },
    
    clearProcessing() {
      // Clear any active processing state when component is destroyed or user navigates away
      if (this.pollingInterval) {
        this.stopPolling();
        this.$store.dispatch('renewableProcessing/clearRenewableProcessing');
      }
    },
  },
  
  // Clean up on component destroy
  beforeUnmount() {
    this.clearProcessing();
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.w-80 {
  width: 80px !important;
}
.el-button--primary {
  color: white !important;
}

.cell {
  text-align: center !important;
}

.upload-demo > ul {
  top: 0 !important;
  left: 0 !important;
}

.session-tab > ul {
  top: 18px !important;
}

.progress-style > .el-progress__text {
  color: white;
  text-align: center;
}
</style>
